module.exports = __webpack_public_path__ + "img/pse-white.767b5329.svg";